import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MobileDeviceService } from '@app/services/mobile-device.service';
import { SeoService } from '@app/services/seo.service';
import { DeviceIdService } from '@app/services/device-id.service';
import { AvoService } from '@avo/services/avo.service';

@Injectable()
export class AppContainerBulkService {

  constructor(
    private readonly seoService: SeoService,
    private readonly avoService: AvoService,
    private readonly mobileDeviceService: MobileDeviceService,
    private readonly deviceIdService: DeviceIdService,
  ) { }

  get isMobileDevice$(): Observable<boolean> {
    return this.mobileDeviceService.isMobileDevice$;
  }

  get isMobileAgent(): boolean {
    return this.mobileDeviceService.isMobileAgent;
  }

  public createLinkForCanonicalURL(): void {
    this.seoService.createLinkForCanonicalURL();
  }

  public setDeviceId(): void {
    this.deviceIdService.setDeviceId();
  }

  public initAvo(): void {
    this.avoService.initAvo();
  }

}
